module.exports = __webpack_public_path__ + "static/media/29BDOS27.03143e76.jpg";